
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace('')
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_9370ODDLG1OvMeta } from "/tmp/menaceking-build-1751635052/pages/[...slug].vue?macro=true";
import { default as autologin5aZTuCAEDPMeta } from "/tmp/menaceking-build-1751635052/pages/auth/autologin.vue?macro=true";
import { default as callbackjRTFsxqEH2Meta } from "/tmp/menaceking-build-1751635052/pages/auth/social/[connection]/callback.vue?macro=true";
import { default as bettingfGow0vnnl2Meta } from "/tmp/menaceking-build-1751635052/pages/betting.vue?macro=true";
import { default as _91pageIdentity_93R4DwMgk9zmMeta } from "/tmp/menaceking-build-1751635052/pages/bonus/[pageIdentity].vue?macro=true";
import { default as _91categoryIdentity_93RBCCekMJSdMeta } from "/tmp/menaceking-build-1751635052/pages/categories/[categoryIdentity].vue?macro=true";
import { default as categoriesCH2T40mpToMeta } from "/tmp/menaceking-build-1751635052/pages/categories.vue?macro=true";
import { default as contactcgTCR5fhP8Meta } from "/tmp/menaceking-build-1751635052/pages/contact.vue?macro=true";
import { default as favorites_46clientnhzz4oqSWZMeta } from "/tmp/menaceking-build-1751635052/pages/favorites.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/tmp/menaceking-build-1751635052/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as _91id_93k0s9tfmsbLMeta } from "/tmp/menaceking-build-1751635052/pages/games/[id].vue?macro=true";
import { default as indexFq4Vlh8M8lMeta } from "/tmp/menaceking-build-1751635052/pages/index.vue?macro=true";
import { default as loyaltyxMEbl2wdsmMeta } from "/tmp/menaceking-build-1751635052/pages/loyalty.vue?macro=true";
import { default as mainw2uf6jw3CpMeta } from "/tmp/menaceking-build-1751635052/pages/main.vue?macro=true";
import { default as bonusesceMPuewIrpMeta } from "/tmp/menaceking-build-1751635052/pages/profile/bonuses.vue?macro=true";
import { default as documentstQPHnpDpUAMeta } from "/tmp/menaceking-build-1751635052/pages/profile/documents.vue?macro=true";
import { default as historyCwEE3u8VApMeta } from "/tmp/menaceking-build-1751635052/pages/profile/history.vue?macro=true";
import { default as infoiMi1y1dYMmMeta } from "/tmp/menaceking-build-1751635052/pages/profile/info.vue?macro=true";
import { default as limits8vYSZpgHVmMeta } from "/tmp/menaceking-build-1751635052/pages/profile/limits.vue?macro=true";
import { default as notificationshMaoRW2U3sMeta } from "/tmp/menaceking-build-1751635052/pages/profile/notifications.vue?macro=true";
import { default as securityMcOB5uI8RQMeta } from "/tmp/menaceking-build-1751635052/pages/profile/security.vue?macro=true";
import { default as verificationVEJosM1CKcMeta } from "/tmp/menaceking-build-1751635052/pages/profile/verification.vue?macro=true";
import { default as walletOQ4hwOx3ygMeta } from "/tmp/menaceking-build-1751635052/pages/profile/wallet.vue?macro=true";
import { default as profile_46clientcRS0mepgveMeta } from "/tmp/menaceking-build-1751635052/pages/profile.client.vue?macro=true";
import { default as providersx9BrIFl9HOMeta } from "/tmp/menaceking-build-1751635052/pages/providers.vue?macro=true";
import { default as _91pageIdentity_937vItSmIhkYMeta } from "/tmp/menaceking-build-1751635052/pages/questions/[pageIdentity].vue?macro=true";
import { default as questions9yAIdjLp3QMeta } from "/tmp/menaceking-build-1751635052/pages/questions.vue?macro=true";
import { default as recently_45played_46client9vPPHJiPUMMeta } from "/tmp/menaceking-build-1751635052/pages/recently-played.client.vue?macro=true";
import { default as _91pageIdentity_93PxkI2lkza9Meta } from "/tmp/menaceking-build-1751635052/pages/static/[pageIdentity].vue?macro=true";
import { default as _91identity_93WRTYt83y1fMeta } from "/tmp/menaceking-build-1751635052/pages/tournaments/[identity].vue?macro=true";
import { default as indexw6f0wYl2iJMeta } from "/tmp/menaceking-build-1751635052/pages/tournaments/index.vue?macro=true";
import { default as welcome_45packageZfo5Cxi0fdMeta } from "/tmp/menaceking-build-1751635052/pages/welcome-package.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/tmp/menaceking-build-1751635052/pages/[...slug].vue")
  },
  {
    name: "auth-autologin",
    path: "/auth/autologin",
    component: () => import("/tmp/menaceking-build-1751635052/pages/auth/autologin.vue")
  },
  {
    name: "auth-social-connection-callback",
    path: "/auth/social/:connection()/callback",
    component: () => import("/tmp/menaceking-build-1751635052/pages/auth/social/[connection]/callback.vue")
  },
  {
    name: "betting",
    path: "/betting",
    component: () => import("/tmp/menaceking-build-1751635052/pages/betting.vue")
  },
  {
    name: "bonus-pageIdentity",
    path: "/bonus/:pageIdentity()",
    component: () => import("/tmp/menaceking-build-1751635052/pages/bonus/[pageIdentity].vue")
  },
  {
    name: "categories",
    path: "/categories",
    meta: categoriesCH2T40mpToMeta || {},
    component: () => import("/tmp/menaceking-build-1751635052/pages/categories.vue"),
    children: [
  {
    name: "categories-categoryIdentity",
    path: ":categoryIdentity()",
    component: () => import("/tmp/menaceking-build-1751635052/pages/categories/[categoryIdentity].vue")
  }
]
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/tmp/menaceking-build-1751635052/pages/contact.vue")
  },
  {
    name: "favorites",
    path: "/favorites",
    component: () => createClientPage(() => import("/tmp/menaceking-build-1751635052/pages/favorites.client.vue"))
  },
  {
    name: "games-id",
    path: "/games/:id()",
    component: () => import("/tmp/menaceking-build-1751635052/pages/games/[id].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/menaceking-build-1751635052/pages/index.vue")
  },
  {
    name: "loyalty",
    path: "/loyalty",
    component: () => import("/tmp/menaceking-build-1751635052/pages/loyalty.vue")
  },
  {
    name: "main",
    path: "/main",
    component: () => import("/tmp/menaceking-build-1751635052/pages/main.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => createClientPage(() => import("/tmp/menaceking-build-1751635052/pages/profile.client.vue")),
    children: [
  {
    name: "profile-bonuses",
    path: "bonuses",
    component: () => import("/tmp/menaceking-build-1751635052/pages/profile/bonuses.vue")
  },
  {
    name: "profile-documents",
    path: "documents",
    component: () => import("/tmp/menaceking-build-1751635052/pages/profile/documents.vue")
  },
  {
    name: "profile-history",
    path: "history",
    component: () => import("/tmp/menaceking-build-1751635052/pages/profile/history.vue")
  },
  {
    name: "profile-info",
    path: "info",
    component: () => import("/tmp/menaceking-build-1751635052/pages/profile/info.vue")
  },
  {
    name: "profile-limits",
    path: "limits",
    component: () => import("/tmp/menaceking-build-1751635052/pages/profile/limits.vue")
  },
  {
    name: "profile-notifications",
    path: "notifications",
    component: () => import("/tmp/menaceking-build-1751635052/pages/profile/notifications.vue")
  },
  {
    name: "profile-security",
    path: "security",
    component: () => import("/tmp/menaceking-build-1751635052/pages/profile/security.vue")
  },
  {
    name: "profile-verification",
    path: "verification",
    component: () => import("/tmp/menaceking-build-1751635052/pages/profile/verification.vue")
  },
  {
    name: "profile-wallet",
    path: "wallet",
    component: () => import("/tmp/menaceking-build-1751635052/pages/profile/wallet.vue")
  }
]
  },
  {
    name: "providers",
    path: "/providers",
    component: () => import("/tmp/menaceking-build-1751635052/pages/providers.vue")
  },
  {
    name: "questions",
    path: "/questions",
    meta: questions9yAIdjLp3QMeta || {},
    component: () => import("/tmp/menaceking-build-1751635052/pages/questions.vue"),
    children: [
  {
    name: "questions-pageIdentity",
    path: ":pageIdentity()",
    component: () => import("/tmp/menaceking-build-1751635052/pages/questions/[pageIdentity].vue")
  }
]
  },
  {
    name: "recently-played",
    path: "/recently-played",
    component: () => createClientPage(() => import("/tmp/menaceking-build-1751635052/pages/recently-played.client.vue"))
  },
  {
    name: "static-pageIdentity",
    path: "/static/:pageIdentity()",
    component: () => import("/tmp/menaceking-build-1751635052/pages/static/[pageIdentity].vue")
  },
  {
    name: "tournaments-identity",
    path: "/tournaments/:identity()",
    component: () => import("/tmp/menaceking-build-1751635052/pages/tournaments/[identity].vue")
  },
  {
    name: "tournaments",
    path: "/tournaments",
    component: () => import("/tmp/menaceking-build-1751635052/pages/tournaments/index.vue")
  },
  {
    name: "welcome-package",
    path: "/welcome-package",
    component: () => import("/tmp/menaceking-build-1751635052/pages/welcome-package.vue")
  }
]